<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                v-if="hasPerm('configuration.create')"
                                @invoke-method="invokeMethod($event)"
                                action="openFePartCategoryForm"
                            ></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetFePartCategories(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="fe_part_categories" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openFePartCategoryForm(props.item)">
                                <td>{{ props.item.category_id }}</td>
                                <td>{{ props.item.category_name }}</td>
                                <td>{{ props.item.category_description }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="fe_part_categories"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="fe_part_category_dialog">
                <v-card>
                    <v-form ref="form_fe_part_category">
                        <v-card-title>
                            <span class="headline">{{
                                fe_part_category.category_id ? $t("lang.edit_fe_part_category") : $t("lang.add_fe_part_category")
                            }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeFePartCategoryDialog"
                                :dialog-status="fe_part_category_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="fe_part_category.category_name"
                                            :label="$t('lang.category_name')"
                                            :counter="showCounter(fe_part_category.category_name, 'fe_part_categories.category_name')"
                                            :rules="ifValid('fe_part_categories.category_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea
                                            v-model="fe_part_category.category_description"
                                            :label="$t('lang.category_description')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('fe_part_categories.category_description')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="fe_part_category.category_id" color="error" @mouseup.left="$refs.delete_fe_part_categories.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeFePartCategoryDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveFePartCategories">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_part_categories"
                :heading="$t('lang.delete_fe_part_category')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteFePartCategories(fe_part_category.category_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openFePartCategoryForm" },
                { title: this.$t("lang.refresh"), action: "dbGetFePartCategories", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.category_id"), sortable: false, width: "33%" },
                { text: this.$t("lang.category_name"), sortable: false, width: "33%" },
                { text: this.$t("lang.category_description"), sortable: false, width: "33%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            fe_part_category: {},
            filter: {
                search: "",
                status: "1",
            },
            fe_part_category_dialog: false,
            dbGetFePartCategories: _.debounce(this.getFePartCategories, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchFePartCategories", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.fe_part_categories) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchFePartCategories({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.fe_part_categories) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.fe_part_categories.fe_part_categories_filter,
            page: (state) => state.fe_part_categories.page,
            rules_fe_part_categories: (state) => state.fe_part_categories.rules_fe_part_categories,
            fe_part_category_status_options: (state) => state.settings.fe_part_category_status_options,
            fe_part_categories: (state) => state.fe_part_categories.fe_part_categories,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchFePartCategories", "saveFePartCategory", "deleteFePartCategory"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openFePartCategoryForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_fe_part_category) item ? this.$refs.form_fe_part_category.resetValidation() : this.$refs.form_fe_part_category.reset();

                    this.$nextTick(() => {
                        this.fe_part_category = item != null ? this.assignObj2(item, this.rules_fe_part_categories) : {};
                        this.fe_part_category_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "fe_part_category", params: { id: item.category_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_fe_part_category) item ? this.$refs.form_fe_part_category.resetValidation() : this.$refs.form_fe_part_category.reset();
                    this.fe_part_category_dialog = true;
                } else {
                    this.$router.push({ name: "fe_part_category" });
                }
            }
        },
        saveFePartCategories() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_fe_part_category")) {
                    let body = this.prepForm(this.fe_part_category, this.rules_fe_part_categories);

                    this.saveFePartCategory({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getFePartCategories();
                                this.closeFePartCategoryDialog();
                            } else {
                                this.$router.push({ name: "fe_part_category", params: { id: data.category_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteFePartCategories(id = null) {
            this.deleteFePartCategory({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getFePartCategories();
                    this.closeFePartCategoryDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeFePartCategoryDialog() {
            this.fe_part_category_dialog = false;
            this.$refs.delete_fe_part_categories.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getFePartCategories(pg_refresh = false) {
            this.startLoader();

            this.fetchFePartCategories({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.fe_part_category_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
    },
};
</script>
